import { useEffect } from "react";

import { featureFlags } from "#/config/featureFlags";
import { ButtonFeatureFlag } from "#/types/featureFlags";

import { useHandleLogOut } from "../useHandleLogOut";
import { useFeatureFlags } from "./useFeatureFlags";

export const useWalletButtonFeatureFlag = () => {
  const { handleLogOut } = useHandleLogOut();

  const walletButtonFlag = useFeatureFlags<ButtonFeatureFlag>(
    featureFlags.walletButton,
  ) ?? {
    isEnabled: true,
    title: "Connect Wallet",
  };

  useEffect(() => {
    if (!walletButtonFlag.isEnabled) {
      handleLogOut();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- handleLogOut is wrapped with useEffectEvent, which causes it to have a stable identity and not need to be included in the dependency array
  }, [walletButtonFlag.isEnabled]);

  return walletButtonFlag;
};
